// App-wide constants.

// AFT org leader — the ownership hierarchy is capped here (never shows anyone above).
// Keep in sync with AFT_LEADER in the Lambda's OrgHierarchyActivity.
export const AFT_LEADER = 'aagiwal';

// Default filters for the org-hierarchy landing view.
export const DEFAULT_ORG = 'AFT';
export const DEFAULT_TIER = 'tier-1';

// Central-team reviewers — approver 2 is chosen from this list by the submitter.
// Keep in sync with CENTRAL_TEAM in the Lambda's CustomMetricsActivity.
export const CENTRAL_TEAM = ['samasamb', 'prasry', 'saratrag', 'sateesh', 'arvele', 'kartikr', 'sunilmsk'];
